import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  SimpleChange,
} from '@angular/core';
import { Router } from '@angular/router';

import { BehaviorSubject, combineLatest, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { IconName } from '@recruitee/user-interface';

import { FeatureGuardFacade } from '../feature-guard.facade';
import { FeaturesGuardModel } from '../feature-guard.model';
import { FeatureGuardComponent, FeatureGuardMode, GuardedFeature } from '../feature-guard.types';

@Component({
  selector: 'rt-feature-guard-sidebar-item',
  templateUrl: 'feature-guard-sidebar-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeatureGuardSidebarItemComponent implements FeatureGuardComponent {
  @Input() public forceEnabled: boolean = false;
  @Input() public mode: FeatureGuardMode;
  @Input() public feature: GuardedFeature;
  @Input() public name: string;
  @Input() public icon: IconName;
  @Input() public addMargin: boolean | null;

  public href: string | null;
  public enabled: boolean = false;
  public features: string[];

  private forceEnabled$ = new BehaviorSubject<boolean>(this.forceEnabled);
  private ngOnDestroy$ = new Subject<void>();

  constructor(
    public facade: FeatureGuardFacade,
    public router: Router,
    private model: FeaturesGuardModel,
    protected cdRef: ChangeDetectorRef,
  ) {}

  public ngOnInit() {
    combineLatest([this.facade.checkFeatureAvailability(this.feature), this.forceEnabled$])
      .pipe(takeUntil(this.ngOnDestroy$))
      .subscribe(([isEnabled, isForceEnabled]) => {
        this.enabled = isForceEnabled || isEnabled;
        this.href = this.model.data[this.feature].upgradeUrl;
        this.cdRef.detectChanges();
      });
  }

  public ngOnChanges({ forceEnabled }: { forceEnabled: SimpleChange }) {
    if (forceEnabled) {
      this.forceEnabled$.next(this.forceEnabled);
    }
  }

  public ngOnDestroy(): void {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }
}
